/**
 * @generated SignedSource<<cc51c8aae5160853d6b55433ef85aca5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityStatus_activity$data = {
  readonly completed: boolean;
  readonly completedAt: string | null | undefined;
  readonly date: string | null | undefined;
  readonly enrollment: {
    readonly client: {
      readonly displayName: string | null | undefined;
    };
  } | null | undefined;
  readonly formattedDate: string | null | undefined;
  readonly " $fragmentType": "ActivityStatus_activity";
};
export type ActivityStatus_activity$key = {
  readonly " $data"?: ActivityStatus_activity$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityStatus_activity">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "format",
  "value": "MMM Do"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActivityStatus_activity",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "raw",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "date",
      "storageKey": "date(raw:true)"
    },
    {
      "alias": "formattedDate",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "utc",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "date",
      "storageKey": "date(format:\"MMM Do\",utc:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v0/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "completedAt",
      "storageKey": "completedAt(format:\"MMM Do\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Enrollment",
      "kind": "LinkedField",
      "name": "enrollment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "client",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Activity",
  "abstractKey": null
};
})();

(node as any).hash = "4a0802e509665807b878308ece12605d";

export default node;
